module.exports = __webpack_public_path__ + "static/img/newFood8.e63333d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newFood8.png
// module id = 2vou
// module chunks = 2